module.exports = __webpack_public_path__ + "img/sketch.0f0f29d6.png";